import React, { Component } from 'react';
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import moment from "moment";

// Componentes
import Select from "../../components/common/virtualized-select";
import VirtualizedTable from "../common/virtualized-table";
import DateInput from "../common/date-input";
import {projectTasks} from "../../components/common/project-tasks"
import {isFloat} from "validator";

class EmployeeWorkReportsDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canPushWorkReport: false,
            project: -1,
            date: moment(),
            cost_per_hour: props.employee.get('cost_per_hour') || 0,
            hours: '',
            task: -1,
            workReports: List([])
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }
    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    onSaveButtonClick = () => {
        this.props.onSaveWorkReports(this.state.workReports, {
            projection: 'date project task hours cost',
            populateRefs: true
        });
        this.props.onCloseModal();
    };

    validateSubmit = () => {
        this.props.onCanSubmit(this.state.workReports.size > 0);
    };

    validateWorkRecord = () => {
        this.setState({
            canPushWorkReport: this.state.project !== -1 && this.state.date.isValid() && this.state.task !== -1 && this.state.hours > 0
        })
    };

    render() {

        // New Work Records Table
        let tableSettings = {
            sortable: false,
            filterable: false,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 160,
            rowHeight: 40,
            strippedRows: false
        };
        let tableData = this.state.workReports;
        let tableColumns = {
            date: {
                title: "Fecha",
                columnType: 'function',
                dataField: 'date',
                width: 100,
                style: {},
                sortable: false,
                filterable: true,
                nodeContent: (date) => {
                    return moment(date).format('DD/MM/YYYY') ;
                }
            },
            project: {
                title: "Proyecto",
                columnType: 'function',
                dataField: 'project',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (projectId) => {
                    return this.props.projects.find(project => project.get('_id') === projectId).get('name');
                }
            },
            task: {
                title: "Tarea",
                columnType: 'function',
                dataField: 'task',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (task_code) => {
                    return projectTasks.find(task => task.get('task_code') === task_code).get('name');
                }
            },
            hours: {
                title: "Horas",
                columnType: 'text',
                dataField: 'hours',
                width: 100,
                style: {},
                sortable: false,
                filterable: false
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (workRecordId) => {
                    return (
                        <Icon className="cursor-pointer" icon="trash" title="Eliminar" onClick={() => {
                            let updatedNewWorkRecords = List([]);

                            this.state.workReports.delete(workRecordId).map((workRecord, index) => {
                                return updatedNewWorkRecords = updatedNewWorkRecords.push(workRecord.merge({ _id: index }));
                            });
                            this.setState({ workReports: updatedNewWorkRecords }, this.validateSubmit)
                        }} />
                    );
                }
            }
        };

        return (
            <div>
                <div className="row modal-row">
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Empleado</label>
                        <input
                            className="form-control"
                            type="text"
                            value={`[${this.props.employee.get('employee_code')}] ${this.props.employee.get('name')}`}
                            disabled={true}
                        />
                    </div>
                    <div className="col-4">
                        <div className="form-group">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Fecha</label>
                            <DateInput
                                onChange={(selectedValue) => this.setState({
                                    date: selectedValue
                                }, this.validateWorkRecord)}
                                value={this.state.date}
                                inputWrapperStyle={{height: 40}}
                                inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                iconStyle={{top: 9, right: 12}}
                            />
                        </div>
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Proyecto</label>
                        <Select
                            className="virtualized-select"
                            options={this.props.projects.toJS()}
                            value={this.state.project}
                            labelKey="select"
                            valueKey="_id"
                            matchProp="select"
                            multi={false}
                            searchable={true}
                            clearable={false}
                            onChange={(project) => {
                                if (project) {
                                    this.setState({
                                        project: project._id
                                    }, this.validateWorkRecord);
                                }
                            }}
                        />
                    </div>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Tarea</label>
                        <Select
                            className="virtualized-select"
                            options={projectTasks.toJS()}
                            value={this.state.task}
                            labelKey="name"
                            valueKey="task_code"
                            matchProp="name"
                            multi={false}
                            searchable={true}
                            clearable={false}
                            onChange={(task) => {
                                if (task) {
                                    this.setState({ task: task.task_code }, this.validateWorkRecord);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="row modal-row" style={{ paddingTop: 10 }}>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Coste por hora</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.cost_per_hour}
                            onChange={ (event) => {
                                let cost_per_hour = event.target.value;
                                if (cost_per_hour === '') cost_per_hour = '0';
                                if (isFloat(cost_per_hour)) {
                                    this.setState({ cost_per_hour }, this.validateWorkRecord);
                                }
                            }}
                        />
                    </div>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Horas</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.hours}
                            onChange={ (event) => {
                                let hours = event.target.value;
                                if (hours === '') hours = '0';
                                if (isFloat(hours)) {
                                    this.setState({ hours }, this.validateWorkRecord);
                                }
                            }}
                        />
                    </div>
                    <div className="col-auto mr-auto" style={{ paddingTop: 27 }} >
                        <button
                            className="btn btn-custom"
                            onClick={ () => {
                                const workRecord = Map({
                                    _id: this.state.workReports.size,
                                    employee: this.props.employee.get('_id'),
                                    project: this.state.project,
                                    date: this.state.date,
                                    hours: this.state.hours,
                                    task: this.state.task,
                                    cost: this.state.cost_per_hour * this.state.hours,
                                });

                                this.setState({
                                    project: -1,
                                    date: moment(),
                                    hours: '',
                                    task: -1,
                                    workReports: this.state.workReports.push(workRecord)
                                }, () => {
                                    this.validateWorkRecord();
                                    this.validateSubmit();
                                })
                            }}
                            disabled={!this.state.canPushWorkReport}
                        >Añadir</button>
                    </div>
                </div>
                <div className="row modal-row" style={{ paddingTop: 10 }}>
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={tableSettings}
                            tableColumns={tableColumns}
                            tableData={tableData}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default EmployeeWorkReportsDialog;


// WEBPACK FOOTER //
// ./src/components/dialogs/EmployeeWorkReportsDialog.js